<div class="row do-not-print">
  <div class="col-md-10 offset-md-2 text-left my-3 col-12">
    <h1 class="title">{{title}}</h1>
  </div>
</div>

<div class="row">
  <div class="card offset-md-2 col-md-10 col-print-12 col-12 odp-xs-card-margin-top">
    <div class="card-body text-left">
      <div class="row">
        <div class="col-md-12 text-center">
          <b>{{absListTitleStart}}</b><i>{{absDatesTitleStart}}</i><b>{{absListTitleEnd}}</b><i>{{absDatesTitleEnd}}</i> {{projectConnectingText}} <strong>{{activeProjectTitle}}</strong>
          <br />
          <b>{{absCountTitle}}</b>
        </div>
      </div>
      <div class="row do-not-print">
        <div class="col-md-12 text-center">
          <h1 class="title"><button class="btn btn-primary " mat-raised-button onClick="window.print();return false;">Print Abstracts</button></h1>
        </div>
      </div>
    </div>
  </div>
</div>
<div *ngIf="abstractsData.abstractResult">
  <div *ngFor="let abstract of abstractsData.abstractResult; let ap = index">
    <div class="row" style="page-break-after:always;">
      <div class="card offset-md-2 col-md-10 col-print-12 col-12 odp-xs-card-margin-top">
        <div class="card-body text-left">
          <br />
          <br />
          <div class="details-row">
              <mat-card class="odp-text-abstract-subheader col-md-3">Abstract Details:</mat-card>
              <div class="abstract-info">
                <div *ngIf="abstract.inReviewList" class="detail-flag">
                  <mat-icon class="sm-icon">check</mat-icon> In Reconciliation List
                </div>
                <div *ngIf="isCoderQList && abstract.reviewRecommended" class="detail-flag">
                  <mat-icon class="sm-icon">check</mat-icon> QC Coder Question
                </div>
                <div *ngIf="isCoderQList && abstract.adjudicationRecommended" class="detail-flag">
                  <mat-icon class="sm-icon">check</mat-icon> Request ODP Adjudication
                </div>
              </div>
          </div>
            <div class="row" *ngIf="abstract">
              <div class="col-md-12 odp-col-padding">
                <br />
                <b>Application ID: {{abstract.application}}</b><br />
                <b>Coders:</b> {{abstract.coderTeamUsers}}<br />
                <b>Date Modified:</b> {{abstract.statusDate | date}}<br />
                <b>FY:</b> {{abstract.fy}}<br />
                <b>Administering IC:</b> {{abstract.administeringIc}}<br />
                <b>Project Title: </b> <span class="title-text"> {{abstract.projectTitle}}</span><br />
                <b>PI Project Leader:</b> {{abstract.piProjectLeader}}<br />
                <b>Project Number:</b> {{abstract.projectNumber}}<br />
              </div>
            </div>

            <div *ngIf="isCoderQList && abstract.coderNotes.length > 0">
              <mat-card class="odp-text-abstract-subheader col-md-3">QC Notes:</mat-card>
              <br />
              <div *ngFor="let note of abstract.coderNotes; index as i">
                <div *ngIf="note.parentNoteId == null">
                  <div class="col-md-12" style="padding-left: 24px;">
                    <span *ngIf="note != null && note.applicationUser !=null && note.applicationUser.friendlyName !=null"><b>{{note.lastModifiedDate | date}} - {{note.applicationUser.firstName}} {{note.applicationUser.lastName}}: </b>{{note.notePlain}}</span>
                  </div>
                </div>
                <div class="subNote" *ngFor="let childNote of abstract.coderNotes">
                  <div *ngIf="childNote.id == note.parentNoteId ">
                    <div class="col-md-12" style="padding-left: 24px;">
                      <span *ngIf="i !== 0">----</span>
                      <span *ngIf="childNote != null && childNote.applicationUser !=null && childNote.applicationUser.friendlyName !=null"><b>{{childNote.lastModifiedDate | date}} - {{childNote.applicationUser.firstName}} {{childNote.applicationUser.lastName}}: </b>{{childNote.notePlain}}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <mat-card class="odp-text-abstract-subheader col-md-3">Description:</mat-card>
            <br />
            <div class="row" *ngIf="abstract.descPart">
              <div class="col-md-12">
                <p>{{abstract.descPart}}</p>
              </div>
            </div>
            <mat-card class="odp-text-abstract-subheader col-md-3">Public Health Relevance:</mat-card>
            <br />
            <div class="row" *ngIf="abstract.publicHealthPart">
              <div class="col-md-12">
                <p>{{abstract.publicHealthPart}}</p>
                <br />
                <br />
              </div>
            </div>
          </div>
      </div>
    </div>
  </div>
</div>
